import axios from 'axios'

export const getInfoLinea = async (simNumber: string) => {
  const fetchUrl = '/mobileActivation/get_info_linea'
  const { data } = await axios.post(fetchUrl, { sim: simNumber })
  return data
}

export const validatePosSim = async (request: Record<string, string>) => {
  const fetchUrl = '/mobileActivation/valida_pos_sim'
  const { data } = await axios.post(fetchUrl, request)
  return data
}
